import { ActivityLog, FormattedActivityLog } from "@idw-types/data/reports";
import { ActivityLogActionTypes } from "@enums/activity-log-action-types";
import { ActivityLogTypes } from "@enums/activity-log-types";
import { ChangeRequestTypes } from "@enums/change-request-types";

export const formatActivityLogs = (
    activityLogs: Array<ActivityLog>
): Array<FormattedActivityLog> => {
    return activityLogs.map(al => formatActivityLog(al));
};

export const formatActivityLog = (
    activityLog: ActivityLog
): FormattedActivityLog => {

    let date = null;
    if (activityLog.date) {
        date = new Date(parseInt(activityLog.date));
    }

    const label = getActivityLabel(activityLog.type);
    const verb = getActivityVerb(activityLog.action);
    const type = getActivityType(activityLog.type);
    const typePrefix = getActivityTypePrefix(activityLog.action, activityLog.type, activityLog.changeRequestType);
    const typeSuffix = getActivityTypeSuffix(activityLog.action, activityLog.type);
    let description = `${verb}`;

    if (typePrefix) {
        description += ` ${typePrefix}`;
    }
    if (type) {
        description += ` ${type}`;
    }
    if (typeSuffix) {
        description += ` ${typeSuffix}`;
    }
    if (activityLog.comments) {
        description += ` ${activityLog.comments}`;
    }

    return {
        date: date,
        type: activityLog.type,
        action: activityLog.action,
        label: label,
        description: description,
        axnAdminUser: activityLog.axnAdminUser,
        changeRequestType: activityLog.changeRequestType,
        organizationID: activityLog.organizationID,
        relyingPartyID: activityLog.relyingPartyID,
        comments: activityLog.comments,
        id: activityLog.id
    };
};

const getActivityLabel = (type: ActivityLogTypes) => {
    switch (type) {
        case ActivityLogTypes.USER_INVITATION:
            return 'User Invitations';
        case ActivityLogTypes.ORGANIZATION:
            return 'Organization';
        case ActivityLogTypes.RELYING_PARTY:
            return 'Relying Party';
        case ActivityLogTypes.USER:
            return 'User';
        case ActivityLogTypes.RPSERVICE:
            return 'Verification Service';
        case ActivityLogTypes.WORKFLOW:
            return 'Workflow';
        default:
            return "";
    }
}

const getActivityVerb = (action: ActivityLogActionTypes) => {
    switch (action) {
        case ActivityLogActionTypes.SCHEDULED_DEPLOYMENT:
            return "scheduled a deployment";
        default:
            return action.toLowerCase();
    }
};

const getActivityType = (type: ActivityLogTypes) => {
    switch (type) {
        case ActivityLogTypes.USER_INVITATION:
            return 'user invitation';
        case ActivityLogTypes.ORGANIZATION:
            return 'organization';
        case ActivityLogTypes.RELYING_PARTY:
            return 'relying party';
        case ActivityLogTypes.USER:
            return 'user';
        case ActivityLogTypes.RPSERVICE:
        case ActivityLogTypes.WORKFLOW:
            return 'change request';
        default:
            return "";
    }
};

const getActivityTypePrefix = (action: ActivityLogActionTypes, type: ActivityLogTypes, changeRequestType: ChangeRequestTypes) => {
    let prefix = 'the';
    if (action === ActivityLogActionTypes.CREATED) {
        prefix = "a new";
    }
    if (type === ActivityLogTypes.RPSERVICE || type === ActivityLogTypes.WORKFLOW) {
        prefix += ` ${changeRequestType}`;
    }
    return prefix;
};

const getActivityTypeSuffix = (action: ActivityLogActionTypes, type: ActivityLogTypes) => {
    let suffix = "";

    if (action === ActivityLogActionTypes.CREATED && type === ActivityLogTypes.USER_INVITATION) {
        suffix = "for";
    } else if (action === ActivityLogActionTypes.MODIFIED && type === ActivityLogTypes.USER_INVITATION) {
        suffix = "for";
    } else if (action === ActivityLogActionTypes.MODIFIED && type === ActivityLogTypes.ORGANIZATION) {
        suffix = "name to";
    }
    return suffix;
};